import { TimeSlot } from '@brands/Dashboard/PatientForms/PatientForm/utils/ProviderAvailabilityCard/Components/TimeSlotComponent';
import qs from 'qs';

import { client } from '../client';
import { Meta } from '../communication/types/Meta';
import { UserProfile } from './types/UserProfile';

export type CareAdvisorFilterAvailability = 'CaseType.video_call_instant' | 'CaseType.one_report';
export interface ListAvailableCareAdvisorParams {
  date?: string;
  tz: string;
  limit?: number;
  carrier_id?: number;
  language?: string[];
  state?: string;
  license_states?: string[];
  synchronous?: boolean;
  asynchronous?: boolean;
  care_advisor_id?: number;
  patient_id?: number;
  out_of_network?: boolean;
  is_new_design?: boolean;
  case_id?: number;
  case_type?: string;
}
interface ListAvailableCareAdvisor {
  created_at: string;
  id: number;
  sync_time_slots: string[];
  sync_time_intervals: TimeSlot[];
  async_time_slots: string[];
  async_time_intervals: TimeSlot[];
  updated_at: string;
  user: UserProfile;
}

export interface ListAvailableCareAdvisors {
  nodes: ListAvailableCareAdvisor[];
  total: number;
  meta: Meta;
}

export const listAvailableCareAdvisors = async (
  user_type: string,
  params?: ListAvailableCareAdvisorParams,
  userRole?: string,
): Promise<ListAvailableCareAdvisors> => {
  const pathPrefix =
    userRole === 'CareAdvisor' ? '/care_advisor' : userRole === 'Collector' ? '/collector' : '/patients';
  const { data } = await client.get<ListAvailableCareAdvisors>(
    `${pathPrefix}/ca_availabilities/available_care_advisors?${qs.stringify(params, {
      skipNulls: true,
      arrayFormat: 'repeat',
    })}`,
  );

  return data;
};
